import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_29d6ca3c: FaireBrandEntity = {
  token: "b_29d6ca3c",
  type: "brand",
  name: "TOPS Malibu",
  avatarUrl: "https://cdn.faire.com/fastly/e57ef176101977ddf21202d9ce620df96bb28bb0c416fae02fba083c1240bb42.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/1422d26f89fbbcbadea30ed1c101e3087636af9f12179aacd8e1e960a278b548.png",
  logoUrl: "https://cdn.faire.com/fastly/e57ef176101977ddf21202d9ce620df96bb28bb0c416fae02fba083c1240bb42.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/1422d26f89fbbcbadea30ed1c101e3087636af9f12179aacd8e1e960a278b548.png",
  location: "Eugene, OR, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 1061,
  isTopShop: true,
  isInsider: true,
  description: "Our product, designed in Hawaii and California, has been handmade in our Oregon warehouse for over 35 years.\n\nIn the 1980s, TOPS Gallery was born in Malibu, offering unusual functional art. Inspired in a bathtub, I envisioned a candle with a fortune capsule containing messages, charms, and gems hidden inside. We named them Good Fortune Candles®.\n\nEach fortune encourages following your intuition and watching the wonderful doors that open for you. Follow your heart. Stay out of your own way.\n\nWord spread quickly, and we loved hearing our customers' stories of growth and connection. TOPS Malibu has flourished through serendipity, surprise, spontaneity, and creating lasting memories.\n\nNow, the children of our original customers are buying TOPS Malibu products for their families. We've created family memories that are being shared with the next generation, and that is a wonderful feeling. Enjoy!\n\nBest wishes,\n\nJudy Walker\nFounder, Creative Director\n",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:14:02.661Z",
    importedBy: "entity-db-cli"
  }
};
